import { type ReactElement } from 'react';
import { Panel } from './primitives';
import { SkeletonRows, useDelayedFlag } from './skeleton';

/**
 * A panel-shaped placeholder for a screen block that is still loading (D511, audit consoles F07): the library's shimmer
 * lines inside a `Panel`, announced as a `status` with the app's own "Loading" text, and shown only after the library's
 * delay so a fast load never flashes it (the space is held meanwhile, so nothing jumps). Lists use `ListTable loading`
 * and KPIs `StatCard loading` instead. Moved here from four byte-identical app copies (D548).
 */
export function LoadingPanel({ label, rows = 4, framed = true }: { label: string; rows?: number; framed?: boolean }): ReactElement {
  const shown = useDelayedFlag(true);
  const body = <SkeletonRows count={rows} />;
  return (
    <div role="status" aria-busy="true" className="vello-loading" data-pending={shown ? 'false' : 'true'}>
      <span className="vello-sr-only">{label}</span>
      {framed ? <Panel>{body}</Panel> : body}
    </div>
  );
}
